import React, { useEffect, useRef, useState } from "react";
import "./guilty.css";
import motorPlate from "../../assets/img/motor.png";
import CONST from "../../const";
import DatePicker from "react-datepicker2";
import moment from "moment-jalaali";
import { toast } from "react-toastify";
import plateIcon from "../../assets/img/plate.png";
import DatePickerCustom from "../DatePickerCustom/DatePickerCustom";

const Guilty = (props) => {
  const { company } = props;
  const detail = props.detail.supplementary[0];

  useEffect(() => {
    let list = CONST.GUILTY_LIST;
    for (let i = 0; i < list?.length; i++) {
      let names = list[i];
      let emptyElement = document.querySelector("[name=" + names + "]");
      if (emptyElement !== null && emptyElement.previousSibling !== null) {
        emptyElement.previousSibling.classList.add("mandatory");
      }
    }
  }, []);

  useEffect(() => {
    getPlate();
  }, [props.detail]);

  const refExtra = useRef();

  const [plate, setPlate] = useState({});
  const [form, setForm] = useState({
    chassis_number_guilty: detail.chassis_number_guilty,
    motor_number_guilty: detail.motor_number_guilty,
    name_guilty: detail.name_guilty,
    certificate_guilty: detail.certificate_guilty,
    base_number_guilty: detail.base_number_guilty,
    restrictions_guilty: detail.restrictions_guilty || -1,
    nationalCode_guilty: detail.nationalCode_guilty,
    insurance_number_guilty: detail.insurance_number_guilty,
    start_date_guilty:
      detail.start_date_guilty || moment().format("jYYYY/jM/jD"),
    expirationDate_guilty:
      detail.expirationDate_guilty || moment().format("jYYYY/jM/jD"),
    company_guilty: detail.company_guilty,
    financial_guilty: detail.financial_guilty,
    commitment_guilty: detail.commitment_guilty,
    owner_car_guilty: detail.owner_car_guilty,
    unique_code_guilty: detail.unique_code_guilty
      ? detail.unique_code_guilty
      : detail.injured_insurance_unique_code &&
        detail.injured_insurance_unique_code,
    mobile_number_guilty:
      detail.mobile_number_guilty !== null && detail.mobile_number_guilty,
    phone_guilty: detail.phone_guilty,
    disciplinary_guilty: detail.disciplinary_guilty,
    automatic_guilty: detail.automatic_guilty,
    address_guilty: detail.address_guilty,
    car_type_guilty: detail.car_type_guilty ? detail.car_type_guilty : 1,
    car_system_guilty: detail.car_system_guilty,
    license_number_guilty: detail.license_number_guilty,
    color_guilty: detail.color_guilty,
    model_guilty: detail.model_guilty,
    issued_guilty: detail.issued_guilty,
    owner_national_code_guilty: detail.owner_national_code_guilty,
    father_name_guilty: detail.father_name_guilty,
    birthday_guilty: detail.birthday_guilty || moment().format("jYYYY/jM/jD"),
    plate_guilty: "",
    issue_date_guilty: detail.issue_date_guilty,
  });

  const [restrictionsGuiltyOption, setRestrictionsGuiltyOption] = useState(
    +form?.restrictions_guilty === 0
      ? 0
      : +form?.restrictions_guilty === -1
        ? -1
        : 1,
  );

  const [extra, setExtra] = useState(
    !(
      +detail?.restrictions_guilty === 0 || +detail?.restrictions_guilty === -1
    ),
  );

  const alphabet = CONST.ALPHABET;
  const carTypeList = CONST.CAR_TYPE;

  useEffect(() => {
    props.getData({ ...form });
  }, []);

  const getPlate = () => {
    let plate = detail && detail.plate_guilty && detail.plate_guilty.split("-");
    let alphabet =
      plate &&
      plate.filter((item) => {
        return isNaN(item) && item !== "null";
      });
    let number =
      plate &&
      plate.filter((item) => {
        return !isNaN(item) && item !== "null";
      });
    let obj = {};

    if (+detail.car_type_guilty === 2) {
      obj = {
        top: props.detail ? number && number[0] : "",
        down: props.detail ? number && number[1] : "",
      };
    } else {
      obj = {
        left: props.detail ? number && number[1] : "",
        right: props.detail ? number && number[2] : "",
        left2: props.detail ? number && number[0] : "",
        center:
          props.detail && alphabet && alphabet[0]
            ? alphabet && alphabet[0]
            : "الف",
      };
    }

    setPlate(obj);
    let defaultPlate =
      +detail.car_type_guilty !== 2
        ? `${obj.left2 && obj.left2.trim()}-${obj.left && obj.left.trim()}-${obj.center && obj.center.trim()}-${obj.right && obj.right.trim()}`
        : `${obj.top && obj.top.trim()}-${obj.down && obj.down.trim()}`;

    setForm({ ...form, plate_guilty: defaultPlate });
  };

  const handleChangeElement = (event) => {
    let frm = { ...plate };
    frm[event.target.name] = event.target.value;
    setPlate(frm);
    if (
      frm.left !== "" &&
      frm.right !== "" &&
      frm.left2 !== "" &&
      +form.car_type_guilty !== 2
    ) {
      handleSetData({
        name: "plate_guilty",
        value: `${frm.left2 && frm.left2.trim()}-${frm.left && frm.left.trim()}-${frm.center && frm.center.trim()}-${frm.right && frm.right.trim()}`,
      });
    }
    if (frm.down !== "" && frm.top !== "" && +form.car_type_guilty === 2) {
      handleSetData({
        name: "plate_guilty",
        value: `${frm.top && frm.top.trim()}-${frm.down && frm.down.trim()}`,
      });
    }
  };

  const handleFocusElement = (event) => {
    let frm = { ...plate };
    frm[event.target.name] = "";
    setPlate(frm);
  };

  const handleSetData = (e) => {
    let obj = { ...form, [e.name]: e.value };
    setForm((prevState) => ({ ...prevState, [e.name]: e.value }));
    console.log(obj);
    props.getData(obj);
  };

  const handleRestrictions = (event) => {
    if (+event === 1) {
      handleSetData({ name: "restrictions_guilty", value: null });
    } else {
      handleSetData({ name: "restrictions_guilty", value: event });
    }
  };

  return (
    <div
      onKeyDown={() => {
        props.alarm(true);
      }}
      onBlur={handleSetData}
    >
      <div className="insurance-table">
        {!props.editCondition && (
          <div
            onClick={() =>
              toast.error("جهت ایجاد تغییرات بر روی دکمه ویراش کلیک نمایید")
            }
            className={"disable-cover"}
          />
        )}
        <div className="table-head">
          {`مشخصات مقصر حادثه ${form.name_guilty?.length > 0 ? " / " + form.name_guilty : ""}`}
        </div>
        <div className="table-body">
          <div className="table-body-item">
            <span>نوع خودرو :</span>
            <select
              name={"car_type_guilty"}
              value={form.car_type_guilty}
              onChange={(e) => {
                props.alarm(true);
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-select"
            >
              {carTypeList &&
                carTypeList.map((item) => {
                  return <option value={item.id}>{item.title}</option>;
                })}
            </select>
          </div>
          <div className="table-body-item">
            <div>تیپ و سیستم خودرو :</div>
            <input
              name={"car_system_guilty"}
              value={form.car_system_guilty}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>
          <div style={{ justifyContent: "right" }} className="table-body-item">
            اتوماتیک :
            <input
              name={"automatic_guilty"}
              defaultChecked={+form.automatic_guilty === 1}
              value={form.automatic_guilty}
              onChange={(e) => {
                handleSetData({
                  name: e.target.name,
                  value: e.target.checked ? 1 : 2,
                });
              }}
              type={"checkBox"}
              className="table-body-item-checkBox"
            />
          </div>
          <div className="table-body-item" style={{ justifyContent: "unset" }}>
            <span>شماره انتظامی :</span>
            {+form.car_type_guilty !== 2 ? (
              <>
                <img
                  name={"plate_guilty"}
                  className="table-body-item-img"
                  src={plateIcon}
                />
                <input
                  onFocus={(e) => {
                    handleFocusElement(e);
                  }}
                  value={plate.right}
                  onChange={(e) => {
                    handleChangeElement(e);
                  }}
                  name={"right"}
                  maxLength={2}
                  className="table-body-item-right-number"
                />
                <div className="table-body-item-left-number">
                  <input
                    onFocus={(e) => {
                      handleFocusElement(e);
                    }}
                    value={plate.left}
                    onChange={(e) => {
                      handleChangeElement(e);
                    }}
                    name={"left"}
                    maxLength={3}
                  />
                  <select
                    onFocus={(e) => {
                      handleFocusElement(e);
                    }}
                    value={plate.center}
                    onChange={(e) => {
                      props.alarm(true);
                      handleChangeElement(e);
                    }}
                    name={"center"}
                  >
                    <option value={-1}>
                      {plate.center ? plate.center : `انتخاب`}
                    </option>
                    {alphabet &&
                      alphabet.map((item) => {
                        return <option value={item.title}>{item.title}</option>;
                      })}
                  </select>
                  <input
                    onFocus={(e) => {
                      handleFocusElement(e);
                    }}
                    value={plate.left2}
                    onChange={(e) => {
                      handleChangeElement(e);
                    }}
                    name={"left2"}
                    maxLength={2}
                  />
                </div>
              </>
            ) : (
              <>
                <img
                  name={"plate_guilty"}
                  className="table-body-item-img-motor"
                  src={motorPlate}
                />
                <div className="table-body-item-motor-number">
                  <input
                    onFocus={(e) => {
                      handleFocusElement(e);
                    }}
                    value={plate.top}
                    onChange={(e) => {
                      handleChangeElement(e);
                    }}
                    name={"top"}
                    maxLength={3}
                  />
                  <input
                    onFocus={(e) => {
                      handleFocusElement(e);
                    }}
                    value={plate.down}
                    onChange={(e) => {
                      handleChangeElement(e);
                    }}
                    name={"down"}
                    maxLength={5}
                  />
                </div>
              </>
            )}
          </div>
          <div className="table-body-item">
            <div>رنگ :</div>
            <select
              value={form.color_guilty}
              name={"color_guilty"}
              onChange={(e) => {
                props.alarm(true);
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-select"
            >
              <option value={"-1"}>{"انتخاب کنید"}</option>
              {CONST.COLOR &&
                CONST.COLOR.map((item) => {
                  return <option value={item.id}>{item.title}</option>;
                })}
            </select>
          </div>
          <div className="table-body-item">
            مدل :
            <input
              name={"model_guilty"}
              value={form.model_guilty}
              type={"number"}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>
          <div className="table-body-item">
            <div>شماره شاسی :</div>
            <input
              name={"chassis_number_guilty"}
              value={form.chassis_number_guilty}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>
          <div className="table-body-item">
            شماره موتور :
            <input
              name={"motor_number_guilty"}
              value={form.motor_number_guilty}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>
          <div className="table-body-item">
            <span>نام راننده :</span>
            <input
              name={"name_guilty"}
              value={form.name_guilty}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>
          <div className="table-body-item">
            <span>کد ملی راننده:</span>
            <input
              name={"nationalCode_guilty"}
              type={"number"}
              value={form.nationalCode_guilty}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>
          <div className="table-body-item">
            نام پدر :
            <input
              name={"father_name_guilty"}
              value={form.father_name_guilty}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>
          <div className="table-body-item">
            شماره شناسنامه :
            <input
              name={"certificate_guilty"}
              type={"number"}
              value={form.certificate_guilty}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>
          <div className="table-body-item">
            <span>شماره گواهینامه :</span>
            <input
              name={"license_number_guilty"}
              type={"number"}
              value={form.license_number_guilty}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>
          <div className="table-body-item">
            <span>شماره پایه گواهینامه :</span>
            <select
              name={"base_number_guilty"}
              value={form.base_number_guilty}
              className={"table-body-item-select"}
              onChange={(e) => {
                props.alarm(true);
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
            >
              <option value={"-1"}>{"انتخاب کنید"}</option>
              {CONST.BASE_NUMBER &&
                CONST.BASE_NUMBER.map((item) => {
                  return <option value={item.id}>{item.title}</option>;
                })}
            </select>
          </div>

          <div className="datepicker-input-container">
            <div className={"table-body-item"}>
              <span className="mandatory">تاریخ صدور گواهینامه:</span>

              <DatePickerCustom
                name={"issue_date_guilty"}
                value={form.issue_date_guilty}
                defaultValue={form.issue_date_guilty}
                onChange={(e) => {
                  handleSetData({
                    name: "issue_date_guilty",
                    value: moment(e).format("jYYYY/jM/jD"),
                  });
                }}
                shouldHighlightWeekends
              />
            </div>
          </div>

          <div ref={refExtra} className="table-body-item">
            <span>محدودیت رانندگی :</span>
            <select
              name={"restrictions_guilty"}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
                setExtra(+e.target.value === 1);
                setRestrictionsGuiltyOption(+e.target.value);
                handleRestrictions(+e.target.value);
              }}
              className="table-body-item-select"
            >
              <option value={"-1"}>{"انتخاب کنید"}</option>

              {CONST.YES_OR_NO?.map((item) => {
                return (
                  <option
                    selected={item.id === restrictionsGuiltyOption}
                    value={item.id}
                  >
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>

          {extra && (
            <div className="table-body-item">
              <span>توضیحات محدودیت :</span>
              <input
                name={"restrictions_guilty"}
                value={form.restrictions_guilty}
                onChange={(e) => {
                  handleSetData({ name: e.target.name, value: e.target.value });
                }}
                className="table-body-item-input"
              />
            </div>
          )}

          <div className="table-body-item">
            <span>شماره بیمه نامه:</span>
            <input
              name={"insurance_number_guilty"}
              value={form.insurance_number_guilty}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>
          <div className="table-body-item">
            <span>کد یکتا :</span>
            <input
              name={"unique_code_guilty"}
              type={"number"}
              value={form.unique_code_guilty}
              onChange={(e) =>
                handleSetData({ name: e.target.name, value: e.target.value })
              }
              className="table-body-item-input"
            />
          </div>
          <div className="datepicker-input-container">
            {
              <div className={"table-body-item"}>
                <span>تاریخ شروع :</span>
                <DatePicker
                  name={"start_date_guilty"}
                  isGregorian={false}
                  timePicker={false}
                  onChange={(e) => {
                    handleSetData({
                      name: "start_date_guilty",
                      value: moment(e).format("jYYYY/jM/jD"),
                    });
                  }}
                />
              </div>
            }
          </div>
          <div className="datepicker-input-container">
            <div className={"table-body-item"}>
              <span>تاریخ انقضا:</span>
              <DatePicker
                name={"expirationDate_guilty"}
                isGregorian={false}
                timePicker={false}
                onChange={(e) => {
                  handleSetData({
                    name: "expirationDate_guilty",
                    value: moment(e).format("jYYYY/jM/jD"),
                  });
                }}
              />
            </div>
          </div>
          <div className="table-body-item">
            <span>صادره از شرکت بیمه:</span>
            <select
              name={"company_guilty"}
              value={form.company_guilty}
              className={"table-body-item-select"}
              onChange={(e) => {
                props.alarm(true);
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
            >
              <option value={"-1"}>{"انتخاب کنید"}</option>
              {company &&
                company.map((item) => {
                  return <option value={item.id}>{item.title}</option>;
                })}
            </select>
          </div>
          <div className="table-body-item">
            سقف تعهدات مالی :
            <input
              name={"financial_guilty"}
              type={"number"}
              value={form.financial_guilty}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>
          <div className="table-body-item">
            سقف تعهدات جانی :
            <input
              name={"commitment_guilty"}
              type={"number"}
              value={form.commitment_guilty}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>
          <div className="table-body-item">
            نام مالک خودرو :
            <input
              name={"owner_car_guilty"}
              value={form.owner_car_guilty}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>
          <div className="table-body-item">
            کد ملی مالک:
            <input
              name={"owner_national_code_guilty"}
              type={"number"}
              value={form.owner_national_code_guilty}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>
          <div className="datepicker-input-container">
            <div className={"table-body-item"}>
              <div>تاریخ تولد مالک:</div>

              <DatePicker
                isGregorian={false}
                timePicker={false}
                onChange={(e) => {
                  handleSetData({
                    name: "birthday_guilty",
                    value: moment(e).format("jYYYY/jM/jD"),
                  });
                }}
              />
            </div>
          </div>
          <div className="table-body-item">
            صادره از :
            <input
              name={"issued_guilty"}
              value={form.issued_guilty}
              onChange={(e) =>
                handleSetData({ name: e.target.name, value: e.target.value })
              }
              className="table-body-item-input"
            />
          </div>
          <div className="table-body-item">
            تلفن همراه :
            <input
              name={"mobile_number_guilty"}
              type={"number"}
              value={form.mobile_number_guilty}
              onChange={(e) =>
                handleSetData({ name: e.target.name, value: e.target.value })
              }
              className="table-body-item-input"
            />
          </div>
          <div className="table-body-item">
            تلفن ثابت :
            <input
              name={"phone_guilty"}
              type={"number"}
              value={form.phone_guilty}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>

          <div
            style={{ width: "100%", justifyContent: "right" }}
            className="table-body-item"
          >
            آدرس :
            <input
              name={"address_guilty"}
              value={form.address_guilty}
              onChange={(e) => {
                handleSetData({ name: e.target.name, value: e.target.value });
              }}
              className="table-body-item-input"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Guilty;
